import "../../App.css";
import "./Login.css";
import { useState } from "react";
import {
  FaSignInAlt
} from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../components/AuthContext';
import Appconfig from '../../config/config'
import axios from 'axios';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth()
  const [user_nameValidationError, setUser_NameValidationError] = useState("Please enter username");
  const [passwordValidationError, setPasswordValidationError] = useState("Please enter password");
  const [validationError, setValidationError] = useState("");
  const [isLoading, setIsLoading] = useState(false)
  const [welcomeMessage, setWelcomeMessage] = useState("")
  const [formData, setformData] = useState({
    user_name: '',
    password: '',
    site_code: Appconfig.sitecodes,
    user_type: "Super"
  });

  function checkValidation() {
    const usernameErrorElement =
      document.querySelector(".username-error");

    const passwordErrorElement =
      document.querySelector(".password-error");

    let isValid = true;

    const username = formData.user_name.trim();
    const password = formData.password;

    if (!username) {
      setUser_NameValidationError(
        "Please enter username"
      );

      usernameErrorElement?.classList.remove(
        "hidden"
      );

      isValid = false;
    } else {
      const usernameRegex = /^[a-zA-Z0-9]+$/;

      if (!usernameRegex.test(username)) {
        setUser_NameValidationError(
          "Username is only allow a-z and 0-9."
        );

        usernameErrorElement?.classList.remove(
          "hidden"
        );

        isValid = false;
      } else {
        usernameErrorElement?.classList.add(
          "hidden"
        );
      }
    }

    if (!password) {
      setPasswordValidationError(
        "Please enter password"
      );

      passwordErrorElement?.classList.remove(
        "hidden"
      );

      isValid = false;
    } else if (password.length < 6) {
      setPasswordValidationError(
        "Password must be at least 6 characters"
      );

      passwordErrorElement?.classList.remove(
        "hidden"
      );

      isValid = false;
    } else {
      passwordErrorElement?.classList.add(
        "hidden"
      );
    }

    return isValid;
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setformData((previousData) => ({
      ...previousData,
      [name]: value,
    }));

    if (name === "user_name") {
      document
        .querySelector(".username-error")
        ?.classList.add("hidden");
    }

    if (name === "password") {
      document
        .querySelector(".password-error")
        ?.classList.add("hidden");
    }

    setValidationError("");
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!checkValidation()) {
      return;
    }

    authenticateUser(formData);
  };

  const authenticateUser = (credentials) => {
    setIsLoading(true);

    axios({
      method: "post",
      url: `${Appconfig.apiUrl}users/userAuthenticate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify(credentials),
    })
      .then((response) => {
        if (response.data.result) {
          storeUserinfo(response.data.resultData);
        } else {
          setIsLoading(false);
          setValidationError(response.data.resultMessage);
          errorNotification();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Login API error:", error);
        NotificationManager.error(
          "Unable to connect. Please try again.",
          "",
          3000
        );
      });
  };

  function storeUserinfo(userdata) {
    const loginSuccess = login(userdata);

    if (!loginSuccess) {
      setIsLoading(false);

      NotificationManager.error(
        "Login token is missing.",
        "",
        3000
      );

      return;
    }

    setWelcomeMessage(
      `Welcome, ${userdata.user_name ||
      formData.user_name
      }!`
    );

    setTimeout(() => {
      setIsLoading(false);
      navigate("/", { replace: true });
    }, 800);
  }

  const errorNotification = () => {
    NotificationManager.error('Invalid Login Credential!', '', 3000);
  }

  return (
    <main className="login-reference-page">
      <section className="login-reference-main">
        {/* Apna logo */}
        <div className="login-reference-brand">
          <img
            src={`${process.env.PUBLIC_URL}/logo.png`}
            alt="BMW EXCH"
            className="login-reference-logo"
          />
        </div>

        {/* Login modal */}
        <section className="login-reference-card">
          <div className="login-reference-title">
            <span className="login-reference-title-line" />

            <h1>Sign In</h1>

            <span className="login-reference-title-line" />
          </div>

          <form
            method="post"
            onSubmit={handleSubmit}
            autoComplete="off"
            noValidate
            className="login-reference-form"
          >
            <div className="login-reference-field">
              <input
                value={formData.user_name}
                onChange={handleInputChange}
                type="text"
                name="user_name"
                placeholder="Username"
                maxLength={30}
                autoFocus
                autoComplete="username"
              />
            </div>

            <span className="username-error hidden login-reference-error">
              {user_nameValidationError}
            </span>

            <div className="login-reference-field">
              <input
                value={formData.password}
                onChange={handleInputChange}
                type="password"
                name="password"
                placeholder="Password"
                minLength={6}
                autoComplete="current-password"
              />
            </div>

            <span className="password-error hidden login-reference-error">
              {passwordValidationError}
            </span>

            {validationError && (
              <p className="login-reference-api-error">
                {validationError}
              </p>
            )}

            <button
              type="submit"
              className="login-reference-button"
              disabled={isLoading}
            >
              <span>{isLoading ? "Please wait..." : "Login"}</span>
              <FaSignInAlt aria-hidden="true" />
            </button>
          </form>
        </section>
      </section>
    </main>
  );
}

export default Login;
